import { BaseService } from './BaseService'

class PageService extends BaseService {
  getFooterPages () {
    return this.get('/pages/footer')
  }

  getPageBySlug (slug) {
    return this.get(`/pages/${slug}`)
  }
}

export default new PageService()
